import React from 'react';

export const ReportToTonn = (value: any) => <React.Fragment>{value / 1000}</React.Fragment>;
